// extracted by mini-css-extract-plugin
export default {"container":"registrationGeographicSectors_container__RjWS4","lists":"registrationGeographicSectors_lists__qgEuD","list":"registrationGeographicSectors_list__0vGFp"};